var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-dialog",
    {
      attrs: {
        title: "成长值明细",
        visible: _vm.showGrowthStatistics,
        "append-to-body": "",
        width: "80%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showGrowthStatistics = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.statisticsLoading,
              expression: "statisticsLoading",
            },
          ],
          ref: "table",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "", stripe: "" },
        },
        _vm._l(_vm.growthStatisticsTableColumns, function (item, index) {
          return _c("el-table-column", {
            key: index,
            attrs: {
              align: item.align ? item.align : "center",
              prop: item.filed,
              label: item.title,
              width: item.width,
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      item.filed === "remark"
                        ? [
                            _c("span", [_vm._v(_vm._s(scope.row.remarkStr))]),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewOrderDetail(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.orderNo) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        : [
                            _c("span", [
                              _vm._v(_vm._s(scope.row["" + item.filed])),
                            ]),
                          ],
                    ]
                  },
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
      _c(
        "div",
        {
          staticClass: "flex flex-justify-end",
          staticStyle: { "margin-top": "12px" },
        },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.statisticsPageState.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.statisticsPageState.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.statisticsPageState.total,
            },
            on: {
              "size-change": _vm.statisticsHandleSizeChagne,
              "current-change": _vm.statisticsHandleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }